let prod_template=`
{{#if expandable}}
    <nav class="open-close" data-id="{{id}}" data-target="#">
        <span class="expando fa fa-caret-right" />
        <span class="retracto fa fa-caret-down" />
    </nav>
{{/if}}
<i class="fa {{icon}}" data-id=""></i>
<main class="product">
    {{#if relationship_type}}
        <div class="relationship-type info-field">{{relationship_type}}</div>
    {{/if}}
    <div class="name-field">
        <div class="name"><strong>{{name}}</strong></div>
        <div class="id-region">{{! id field region }}</div>
        <div class="account-region">{{! account region }}</div>
    </div>
    <div class="info-field">
        <div class="description info"><strong>Description:</strong> {{#if description}}{{description}}{{else}}<em>no description</em>{{/if}}</div>
    </div>
    <ul class="device-group-region">
        <li class="dev-info zone">
            {{#if show_dev_zone}}
                <a class="action development-dg small">Development Zone</a>
                <ul class="development-info">
                    <li>
                        <i class="fa ei-icon-development_devicegroup text-large" />
                        {{#if show_development_dg}}
                            <a data-toggle="tooltip" data-placement="auto bottom"
                            class="action development-dg"
                            title="Manage this Product’s Development Device Groups and Devices"
                            >Development</a><br>
                            <span class="small">Groups {{devicegroups.development}} | Devices {{devices.development}}</span>
                        {{else}}
                            <span data-toggle="tooltip" data-placement="auto bottom"
                            class="action disabled"
                            title="Development Device Groups are not accessible by this account. Please contact the account owner for permission."
                            >Development</span><br>
                            <span class="small">no access</span>
                        {{/if}}
                    </li>
                </ul>
            {{else}}
                <span class="small">Development Zone</span>
                <div  class="small info">
                    NO ACCESS
                    <i class="fa fa-question-circle" data-toggle="tooltip" data-placement="auto bottom"
                    title="Development Zone is not accessible. Please contact the account owner for permission." />
                </div>
            {{/if}}
        </li>
        <li class="test-info zone">
            {{#if show_test_zone}}
                <a class="action test-production-dg small">Test Zone</a>
                <ul class="test-info">
                    <li class="production-dg">
                        <i class="fa ei-icon-pre_production_devicegroup text-large" />
                            {{#if show_test_production_dg}}
                                <a data-toggle="tooltip" data-placement="auto bottom"
                                class="action test-production-dg"
                                title="Manage this Product's Test Production Device Groups and Devices"
                                >Test Production</a><br>
                                <span class="small">Groups {{devicegroups.pre_production}} | Devices {{devices.pre_production}}</span>
                            {{else}}
                                <span data-toggle="tooltip" data-placement="auto bottom"
                                class="action disabled"
                                title="Test Production Device Groups are not available for this account. Please contact the account owner for permission."
                                >Test Production</span><br>
                                 <span class="small">no access</span>
                            {{/if}}
                    </li>
                    <li class="dut-dg">
                        <i class="fa ei-icon-pre_dut_devicegroup text-large" />       
                            {{#if show_test_dut_dg}}
                                <a data-toggle="tooltip" data-placement="auto bottom"
                                class="action test-dut-dg"
                                title="Manage this Product's Test DUT Device Groups and Devices"
                                >Test DUT</a><br>
                                <span class="small">Groups {{devicegroups.pre_dut}} | Devices {{devices.pre_dut}}</span>
                            {{else}}
                                <span data-toggle="tooltip" data-placement="auto bottom"
                                class="action disabled"
                                title="Test DUT Device Groups are not accessible by this account. Please contact the account owner for permission."
                                >Test DUT</span><br>
                                <span class="small">no access</span>
                            {{/if}}
                    </li>
                    <li class="fixture-dg">
                        <i class="fa ei-icon-pre_factoryfixture_devicegroup text-large" />
                            {{#if show_test_fixture_dg}}
                                <a data-toggle="tooltip" data-placement="auto bottom"
                                class="action test-fixture-dg"
                                title="Manage this Product's Test Fixture Device Groups and Devices"
                                >Test Fixture</a><br>
                                <span class="small">Groups {{devicegroups.pre_factoryfixture}} | Devices {{devices.pre_factoryfixture}}</span>
                            {{else}}
                                <span data-toggle="tooltip" data-placement="auto bottom"
                                class="action disabled"
                                title="Test Fixture Device Groups are not accessible by this account. Please contact the account owner for permission."
                                >Test Fixture</span><br>
                                <span class="small">no access</span>
                            {{/if}}
                    </li>
                </ul>
            {{else}}
                <span class="small">Test Zone</span>
                <div  class="small info">
                    NO ACCESS
                    <i class="fa fa-question-circle" data-toggle="tooltip" data-placement="auto bottom"
                    title="Test Zone is not accessible. Please contact the account owner for permission." />
                </div>
            {{/if}} 
        </li>
        <li class="production-info zone">
            {{#if show_prod_zone}}
                <a class="action production-dg small">Production Zone</a>
                <ul class="production-info">
                    <li class="prod-dg">
                        <i class="fa ei-icon-production_devicegroup text-large" />
                        {{#if show_production_dg}}
                            <a data-toggle="tooltip" data-placement="auto bottom"
                            class="action production-dg"
                            title="Manage this Product’s Production Device Groups and Devices"
                            >Production</a><br>
                            <span class="small">Groups {{devicegroups.production}} | Devices {{devices.production}}</span>
                        {{else}}
                            <span data-toggle="tooltip" data-placement="auto bottom"
                            class="action disabled"
                            title="Production Device Groups are not accessible by this account. Please contact the account owner for permission."
                            >Production</span><br>
                            <span class="small">no access</span>
                        {{/if}}
                    </li>
                    <li class="dut-dg">
                        <i class="fa ei-icon-dut_devicegroup text-large" />
                            {{#if show_dut_dg}}
                                <a data-toggle="tooltip" data-placement="auto bottom"
                                class="action dut-dg"
                                title="Manage this Product’s DUT Device Groups and Devices"
                                >DUT</a><br>
                                <span class="small">Groups {{devicegroups.dut}} | Devices {{devices.dut}}</span>
                            {{else}}
                                <span data-toggle="tooltip" data-placement="auto bottom"
                                class="action disabled"
                                title="DUT Device Groups are not accessible by this account. Please contact the account owner for permission."
                                >DUT</span><br>
                                <span class="small">no access</span>
                            {{/if}}
                    </li>
                    <li class="fixture-dg">
                        <i class="fa ei-icon-factoryfixture_devicegroup" />
                            {{#if show_edit}}
                                <a data-toggle="tooltip" data-placement="auto bottom"
                                class="action fixture-dg"
                                title="Manage this Product’s Fixture Device Groups and Devices"
                                >Fixture</a><br>
                                <span class="small">Groups {{devicegroups.factoryfixture}} | Devices {{devices.factoryfixture}}</span>
                            {{else}}
                                <span data-toggle="tooltip" data-placement="auto bottom"
                                class="action disabled"
                                title="Fixture Device Groups are not accessible by this account. Please contact the account owner for permission."
                                >Fixture</span><br>
                                <span class="small">no access</span>
                            {{/if}}
                    </li>
                </ul>
            {{else}}
                <span class="small">Production Zone</span>
                <div  class="small info">
                    NO ACCESS
                    <i class="fa fa-question-circle" data-toggle="tooltip" data-placement="auto bottom"
                    title="Production Zone is not accessible. Please contact the account owner for permission." />
                </div>
            {{/if}}
            
        </li>
    </ul>

    {{#if show_actions}}
    <nav class="pills">
        <label>Actions</label>
        <ul class="nav nav-pills">
            {{#if show_settings}}
                <li><button class="btn btn-link action settings">Settings</button></li>
            {{/if}}
            {{#if show_delete}}
                <li><button class="btn btn-link action delete">Delete</button></li>
            {{/if}}
        </ul>
    </nav>

    <nav class="actions">
        <div class="dropdown">
            <div class="fa fa-ellipsis-v action-menu" id="dLabel" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" />
            <ul class="dropdown-menu pull-right" aria-labelledby="dLabel">
                {{#if show_settings}}
                    <li><button class="btn btn-link action settings">Settings</button></li>
                {{/if}}
                {{#if show_delete}}
                    <li><button class="btn btn-link action delete">Delete</button></li>
                {{/if}}
            </ul>
        </div>
    </nav>
    {{/if}}
</main>

<div class="relationships-region">{{! relationships region }}</div>`;

import Marionette from 'backbone.marionette';
import Radio from 'backbone.radio';
import Handlebars from 'handlebars';
import IDView from '@/views/id_view';

const globalCh = Radio.channel('global');

function can(perm) {
    let primary = globalCh.request('primary_account');
    let active = globalCh.request('active_account');
    return active.permits(primary, perm);
}

var ProductItemView = Marionette.View.extend({
    ui: {
        name: '.name',
        settings: '.action.settings',
        tooltips: '[data-toggle="tooltip"]',
        expando: '.expando',
        retracto: '.retracto',
        development_devicegroup: '.action.development-dg',
        test_production_dg: '.action.test-production-dg',
        test_dut_dg: '.action.test-dut-dg',
        test_fixture_dg: '.action.test-fixture-dg',
        production_dg: '.action.production-dg',
        dut_dg: '.action.dut-dg',
        fixture_dg: '.action.fixture-dg',
        report: '.action.report',
        delete: '.action.delete'
    },
    regions: {
        id_region: '.id-region',
        devicecount_info: '.devicecount-info',
        deployment_info: '.deployment-info',
        last_deployed_info: '.last-deployed-info',
        relationships_region: '.relationships-region',
    },
    events: {
        'click @ui.delete': 'show_delete_dialog',
        'click @ui.settings': 'show_settings_dialog',
        'click @ui.expando': 'expand',
        'click @ui.retracto': 'retract',
        'click @ui.development_devicegroup': 'show_development_devicegroups',
        'click @ui.test_production_dg': 'show_pre_production_devicegroups',
        'click @ui.test_dut_dg': 'show_pre_dut_devicegroups',
        'click @ui.test_fixture_dg': 'show_pre_factoryfixture_devicegroups',
        'click @ui.production_dg': 'show_production_devicegroups',
        'click @ui.dut_dg': 'show_dut_devicegroups',
        'click @ui.fixture_dg': 'show_fixture_devicegroups',
    },
    initialize: function() {
        this.listenTo(this.model.counts, 'change sync', this.render);
    },
    template: Handlebars.compile(prod_template),
    attributes: function() {
        return {
            "data-id" : this.model.id,
        };
    },
    templateContext: function (options) {
        let icon = 'fa-cube';
        let show_actions = true;

        if ( this.getOption('show_actions') == false ) show_actions = false;
        if ( !can('delete_product') && !can('update_product') ) show_actions = false;

        return {
            icon: icon,
            show_actions: show_actions,
            show_delete: can('delete_product'),
            show_settings: can('update_product'),
            show_development_dg: can('view_development_devicegroups'),
            show_test_production_dg: can('view_pre_production_devicegroups'),
            show_test_dut_dg: can('view_pre_factoryfixture_devicegroups'),
            show_test_fixture_dg: can('view_pre_factoryfixture_devicegroups'),
            show_production_dg: can('view_production_devicegroups'),
            show_dut_dg: can('view_factoryfixture_devicegroups'),
            show_fixture_dg: can('view_factoryfixture_devicegroups'),
            show_dev_zone: can('view_development_devicegroups'),
            show_test_zone: can('view_pre_production_devicegroups') || can('view_pre_factoryfixture_devicegroups'),
            show_prod_zone: can('view_production_devicegroups') || can('view_factoryfixture_devicegroups'),
            show_edit: can('update_factory_devicegroup'),
            expandable: this.getOption('expandable'),
            relationship_type: this.getOption('relationship_type'),
            devicegroups: this.model.counts.get('devicegroups'),
            devices: this.model.counts.get('devices')
        };
    },
    onRender: function() {
        this.ui.retracto.hide();
        this.ui.tooltips.tooltip();
        this.render_info();
        this.listenTo(this.model, 'change', this.render);
    },
    render_info: function() {
        let id_view = new IDView({ model: this.model });
        this.showChildView('id_region', id_view);
    },
    className: 'section full',
    show_delete_dialog: function() {
        globalCh.request('showDeleteProductDialog', this.model);
    },
    show_settings_dialog: function(){
        globalCh.request('showProductSettingsDialog', {model: this.model});
    },
    show_development_devicegroups: function(){
        globalCh.request('show_development_devicegroups', this.model, 'development_devicegroup');
    },
    show_pre_production_devicegroups: function(){
        globalCh.request('show_pre_production_devicegroups', this.model, 'test');
    },
    show_pre_dut_devicegroups: function(){
        globalCh.request('show_pre_dut_devicegroups', this.model, 'test');
    },
    show_pre_factoryfixture_devicegroups: function(){
        globalCh.request('show_pre_factoryfixture_devicegroups', this.model, 'test');
    },
    show_production_devicegroups: function(){
        globalCh.request('show_production_devicegroups', this.model, 'production');
    },
    show_dut_devicegroups: function(){
        globalCh.request('show_dut_devicegroups', this.model, 'production');
    },
    show_fixture_devicegroups: function(){
        globalCh.request('show_factory_devicegroups', this.model, 'production');
    },
});

export default ProductItemView;


